const phoneNo = "13886158651 (徐经理)"
const companyMail = "changlong.xu@foxlean.com"
export default {
  phoneNo,
  companyMail
}



// WEBPACK FOOTER //
// ./src/assets/constant.js